<template>
  <label
    :name="schema.model"
    :id="schema.model"
    v-bind="schema.attributesLabel"
    @contextmenu="selectComponentDEV($event, schema.model)"
    :class="['d-block', getSelectedDEV && 'dev-selected-component', schema.attributesLabel.class]"
  >
    <div :class="['d-flex']">
      <v-icon
        v-if="schema.appendIcon && !schema.tooltip"
        :class="[schema.appendIcon.right ? 'ml-1 order-2' : 'mr-1']"
        v-bind="schema.appendIcon.attributesIcon"
        :disabled="schema.readonly"
      >{{ schema.appendIcon.icon }}</v-icon>
      <v-icon
        v-if="schema.appendIcon && schema.tooltip"
        :class="[schema.appendIcon.right ? 'ml-1 order-2' : 'mr-1']"
        v-bind="schema.appendIcon.attributesIcon"
        :disabled="schema.readonly"
        v-tooltip.top="{
          content: schema.tooltip.text,
          classes: schema.tooltip.tooltipColorClass,
          trigger: schema.tooltip.trigger
        }"
      >{{ schema.appendIcon.icon }}</v-icon>
      {{ value ? value : schema.text }}
    </div>

    <span
      v-if="schema.textHint"
      :class="['d-flex textHint', schema.textHint.class]"
    >{{ schema.textHint.text }}</span>
  </label>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';

export default {
  mixins: [abstractField, devComponentMixin]
};
</script>

<style lang="scss" scoped>
.textHint {
  font-size: 14px;
  width: 100%;
}
</style>
